module.exports = __webpack_public_path__ + "static/img/tapd.06953b8b.png";